export default [
    {
        path: '/Cafcs',
        name: 'Cafcs',
        component: () => import('@/modules/facturacion/cafcs/views/ListadoViews.vue'),
        meta: {
            slug: 'area-ver', // para los permisos
        },
    }
];